import authHeader from "../helpers/authHeader";

const getNewQuestionnaire = async () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/GetNewQuestionnaire`,
    requestOptions
  )
    .then(handleResponse)
    .then((questionnaire) => {
      return questionnaire;
    });
};

const getNewQuestionnaireStaff = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/GetNewQuestionnaireStaff`,
    requestOptions
  )
    .then(handleResponse)
    .then((questionnaire) => {
      return questionnaire;
    });
};

const getCurrentQuestionnaire = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/GetCurrentQuestionnaire`,
    requestOptions
  )
    .then(handleResponse)
    .then((questionnaire) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //console.log(questionnaire);
      sessionStorage.setItem("litigantMenu", JSON.stringify(questionnaire));

      return questionnaire;
    });
};

const getCurrentQuestionnaireStaff = (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/GetCurrentQuestionnaireStaff`,
    requestOptions
  )
    .then(handleResponse)
    .then((questionnaire) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //console.log(questionnaire);
      return questionnaire;
    });
};

const getCurrentUserQuestionnaireStaff = (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/GetCurrentUserQuestionnaireStaff`,
    requestOptions
  )
    .then(handleResponse)
    .then((questionnaire) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //console.log(questionnaire);
      return questionnaire;
    });
};

const getCurrentQuestionnaireAtt = (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/GetCurrentQuestionnaireAtt`,
    requestOptions
  )
    .then(handleResponse)
    .then((questionnaire) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //console.log(questionnaire);
      return questionnaire;
    });
};

const submitNewQuestionnaire = async (questionnaireForm) => {
  //console.log(questionnaireForm);
  await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/PostUserQuestionnaireAnswers`,
    {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(questionnaireForm),
    }
  )
    .then(handleResponse)
    .then((statusMessage) => {
      return statusMessage;
    });
};

const submitNewQuestionnaireStaff = async (questionnaireForm) => {
  //console.log(questionnaireForm);
  await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/PostUserQuestionnaireAnswersStaff`,
    {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(questionnaireForm),
    }
  )
    .then(handleResponse)
    .then((statusMessage) => {
      return statusMessage;
    });
};

const updateCurrentQuestionnaire = async (questionnaireForm) => {
  await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/UpdateQuestionnaireAnswers`,
    {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(questionnaireForm),
    }
  )
    .then(handleResponse)
    .then((statusMessage) => {
      //return submitNewQuestionnaireAnswers(statusMessage, questionnaireAnswers);
      return statusMessage;
    });
};

const updateCurrentQuestionnaireStaff = async (questionnaireForm) => {
  await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/UpdateQuestionnaireAnswersStaff`,
    {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(questionnaireForm),
    }
  )
    .then(handleResponse)
    .then((statusMessage) => {
      //return submitNewQuestionnaireAnswers(statusMessage, questionnaireAnswers);
      return statusMessage;
    });
};

const checkForQuestionnaire = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/ValidUserQuestionnaireExists`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const handleResponse = (response) => {
  //console.log(response);
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        // window.Location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const questionnaireService = {
  getNewQuestionnaire,
  getNewQuestionnaireStaff,
  getCurrentQuestionnaire,
  getCurrentQuestionnaireStaff,
  getCurrentQuestionnaireAtt,
  submitNewQuestionnaire,
  submitNewQuestionnaireStaff,
  updateCurrentQuestionnaire,
  updateCurrentQuestionnaireStaff,
  checkForQuestionnaire,
  getCurrentUserQuestionnaireStaff,
};

export default questionnaireService;
